import type { TattooDesign } from '../../config/designs';
import { en, ru } from '../../i18n/catalog';

export const normalizeSearch = (value: string): string => value.normalize('NFKC').toLocaleLowerCase().replace(/ё/g, 'е').replace(/\s+/g, ' ').trim();

// Aliases belong to style metadata; every localized category is indexed in both languages.
const aliases: Record<string, string[]> = {
  Japanese: ['japan', 'японский', 'японская', 'япония', 'японск'],
  Illustrative: ['illustration', 'иллюстрация', 'иллюстративный', 'иллюстратив'],
  Lettering: ['letter', 'letters', 'надпись', 'надписи', 'леттеринг'],
  Blackwork: ['black work', 'блэкворк', 'блекворк', 'черная графика'],
};

export function matchesDesignSearch(design: TattooDesign, query: string): boolean {
  const terms = normalizeSearch(query).split(' ').filter(Boolean);
  if (!terms.length) return true;
  const styles = [design.category, ...(design.categories || [])];
  const localizedStyles = styles.flatMap((style) => {
    const normalized = normalizeSearch(style);
    const canonical = Object.keys(aliases).find((name) => normalizeSearch(name) === normalized || normalizeSearch(ru[`design.category.${name}` as keyof typeof en] || '') === normalized) || style;
    const key = `design.category.${canonical}` as keyof typeof en;
    return [style, en[key] || '', ru[key] || '', ...(aliases[canonical] || [])];
  });
  const haystack = normalizeSearch([design.name, ...(design.categoryIds || []), ...(design.tags || []), ...localizedStyles].join(' '));
  return terms.every((term) => haystack.includes(term));
}
